import { render, staticRenderFns } from "./salon.vue?vue&type=template&id=016849ce&"
import script from "./salon.vue?vue&type=script&lang=js&"
export * from "./salon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports